import { cdnTemplate } from 'cdnPreprocessor';
import _ from 'lodash';

export default [
  function viralstyleTestimonials() {
    return {
      restrict: 'E',
      replace: false,
      templateUrl: cdnTemplate('/testimonials.dir.html'),
      link: (scope, element) => {
        let $owl = $(element).find('.owl-carousel'), $next;

        const nextTestimonial = function(e) {
          if (e.keyCode == 13) {
            $owl.trigger('next.owl.carousel');

            setTimeout(() => {
              $owl.find('.owl-item.active:first > .testimonial').focus();
            }, 250);
          }
        };

        $owl.owlCarousel({
          autoplay: true,
          loop: true,
          responsive: {
            0: { items: 1, nav: false },
            768: { items: 2, nav: true }
          },
          onInitialized: () => {
            $next = $owl.find('.owl-next');

            $next.attr('tabindex', '0').attr('aria-label', 'press enter to go to the next slide');

            $next.on('keyup', nextTestimonial);
          },
        });

        scope.testimonialFocused = function(e) {

          $owl.find('.testimonial').attr('tabindex', -1);
        };

        scope.testimonialsFocused = function(e) {
          $owl.trigger('stop.owl.autoplay');
          $owl.find('.owl-item.active:first > .testimonial').attr('tabindex', 0);
        };

        _.defer(() => {
          let $boxes = $owl.find('.box');
          let heights = $boxes.map(function() { return $(this).height(); })
          let maxHeight = _.max(heights);
          $boxes.height(maxHeight);
        });

        scope.$on('$destroy', function() {
          $next.off('keyup', nextTestimonial);
        });

      }
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/layout-components/testimonials/testimonials.dir.js